import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    button: {
        textAlign: "center",
        marginTop: theme.spacing(2),
        borderRadius: 40,
        backgroundColor: "inherit",
        opacity: "0.33",
        "&:not(:last-child)": {
            marginRight: theme.spacing(2),
        },
    },
    selected: {
        backgroundColor: theme.palette.primary.main,
        opacity: "1",
        "& span": {
            color: theme.palette.common.white,
            fontWeight: "bold",
        },
    },
    buttonsGroup: {
        textAlign: "center",
        marginBottom: theme.spacing(2),
    },
}));
